import React, { useState, useEffect, useContext } from 'react';
import {
    Grid,
    Button,
    Typography,
    TextField,
} from '@material-ui/core';
import { useSelector, useDispatch } from "react-redux";
import AlertDialog from '../components/AlertDialog';
import { makeStyles } from '@material-ui/core/styles';
import UsersCombo from '../components/UsersCombo';
import { FirebaseContext } from 'common';
import { useTranslation } from "react-i18next";
import MaterialTable from 'material-table';
import moment from 'moment/min/moment-with-locales';

const useStyles = makeStyles(theme => ({
    root: {
        '& > *': {
            margin: theme.spacing(1),
        },
    },
    '@global': {
        body: {
            backgroundColor: theme.palette.common.white,
        },
    },
    container: {
        zIndex: "12",
        color: "#FFFFFF",
    },
    title: {
        color: "#000",
    },
    gridcontainer: {
        alignContent: 'center'
    },
    items: {
        margin: 0,
        width: '100%'
    },
    input: {
        fontSize: 18,
        color: "#000"
    },
    inputdimmed: {
        fontSize: 18,
        color: "#737373"
    },
    carphoto: {
        height: '18px',
        marginRight: '10px'
    },
    buttonStyle: {
        margin: 0,
        width: '100%',
        height: '100%'
    },
    label: {
        transformOrigin: "top right",
        right: 0,
        left: "auto"
      }, 
    inputRtl: {
        "& label": {
          right: 20,
          left: "auto"
        },
        "& legend": {
          textAlign: "right"
        }
      }
}));

export default function AddMoney(props) {
    const { api } = useContext(FirebaseContext);
    const { t, i18n  } = useTranslation();
    const isRTL = i18n.dir();
    const {
        addToWallet,
        editWalletAddRequest
    } = api;
    const settings = useSelector(state => state.settingsdata.settings);
    const dispatch = useDispatch();
    const classes = useStyles();
    const userdata = useSelector(state => state.usersdata);
    const [users, setUsers] = useState(null);
    const [commonAlert, setCommonAlert] = useState({ open: false, msg: '' });
    const [userCombo, setUserCombo] = useState(null);
    const [amount, setAmount] = useState(0);
    const [data,setData] = useState([]);
    const paymentdata = useSelector(state => state.paymentmethods);
    const [driversObj, setDriversObj] = useState();

    useEffect(() => {
        if (paymentdata.requests) {
          setData(paymentdata.requests.filter(request => request.approved !== true));
        } else {
          setData([]);
        }
    }, [paymentdata.requests]);


    useEffect(() => {
        if (userdata.users) {
            let arr = [];
            for (let i = 0; i < userdata.users.length; i++) {
                let user = userdata.users[i];
                arr.push({
                    'firstName': user.firstName,
                    'lastName': user.lastName,
                    'mobile': user.mobile,
                    'email': user.email,
                    'uid': user.id,
                    'desc': user.firstName + ' ' + user.lastName + ' (' + (settings.AllowCriticalEditsAdmin? user.mobile : "Hidden") + ') ' + (settings.AllowCriticalEditsAdmin? user.email : "Hidden"),
                    'pushToken': user.pushToken
                });
            }
            setUsers(arr);
            let obj =  {};
            userdata.users.map((user)=> obj[user.id]=user.firstName + ' ' + user.lastName + ' (' + (settings.AllowCriticalEditsAdmin? user.mobile : "Hidden") + ') ' + (settings.AllowCriticalEditsAdmin? user.email : "Hidden"),)
            setDriversObj(obj);
        }
    }, [userdata.users,settings.AllowCriticalEditsAdmin]);

    const handleAddBalance = () => {
        if(userCombo && userCombo.uid && amount> 0){
            dispatch(addToWallet(userCombo.uid,amount));
            setCommonAlert({ open:true, msg: t('success')});
        }else{
            setCommonAlert({ open:true, msg: t('no_details_error')});
        }
    }

    const handleCommonAlertClose = (e) => {
        e.preventDefault();
        setCommonAlert({ open: false, msg: '' })
    };

    const columns = [
        { title: t('createdAt'), field: 'createdAt', editable:'never', render: rowData => rowData.createdAt?moment(rowData.createdAt).format('lll'):null,cellStyle:{textAlign:isRTL=== 'rtl' ?'right':'left'}},
        { title: t('approved'), field: 'approved', type:'boolean', cellStyle:{ textAlign: 'center'}, initialEditValue: true},
        { title: t('user'), field: 'uid', editable:'never', cellStyle:{ textAlign: 'center'}, 
          render: rowData =>{
              if (rowData && rowData.uid) {
                return driversObj[rowData.uid]
              }
          },
        },
        { title: t('amount'), field: 'amount', editable:'never', type: 'numeric', cellStyle:{ textAlign: 'center'}},
        //{ title: t('receipt'), field: 'receipt', render: rowData => rowData.receipt? <img alt='License' src={rowData.receipt} style={{width: 100}}/>:null,}
        { title: t('receipt'), field: 'receipt', render: rowData =><button onClick={()=>{window.open(rowData.receipt, '_blank')}}> <img alt='Profile' src={rowData.receipt} style={{width: 100}}/></button>,editable: 'never',cellStyle:{textAlign:'center'},headerStyle:{textAlign:'center'}},
    ];

    const editData = (newData) => {
        return settings.AllowCriticalEditsAdmin?
        new Promise((resolve, reject)=> {
          if(newData['approved']){
            setTimeout(() => {
                newData['createdAt'] = new Date().getTime();
                dispatch(addToWallet(newData.uid,newData.amount));
                dispatch(editWalletAddRequest(newData,"Edit"));
                setCommonAlert({ open:true, msg: t('success')});
                resolve();
            }, 600);
            
          } else{
            setTimeout(() => {
                dispatch(editWalletAddRequest(newData,"Edit"));
                resolve();
            }, 600);
          }
        })
        :
        new Promise(resolve => {
          setTimeout(() => {
            resolve();
            alert(t('demo_mode'));
          }, 600);
        })
      }

    return (
        <div className={classes.container} style={{direction:isRTL==='rtl'?'rtl':'ltr'}}>
            <Grid item xs={12} sm={12} md={8} lg={8}>
                <Grid container spacing={2} >
                    <Grid item xs={12}>
                        <Typography component="h1" variant="h5" className={classes.title} style={{textAlign:isRTL==='rtl'?'right':'left'}}>
                            {t('add_to_wallet')}
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        {users ?
                            <UsersCombo
                                className={classes.items}
                                placeholder={t('select_user')}
                                users={users}
                                value={userCombo}
                                onChange={(event, newValue) => {
                                    setUserCombo(newValue);
                                }}      
                            />
                            : null}
                    </Grid>
                    <Grid item xs={12} sm={6} >
                        <TextField
                            id="datetime-local"
                            label={t('amount')}
                            type="text"
                            variant={"outlined"}
                            fullWidth
                            className={isRTL==='rtl'? classes.inputRtl:classes.commonInputStyle}
                            InputProps={{
                                className: classes.input
                            }}
                            value={amount}
                            onChange={event => {
                                const { value } = event.target;
                                setAmount(value === '' || value === null || value === undefined? 0:parseFloat(value));
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} >
                        <Button
                            size="large"
                            onClick={handleAddBalance}
                            variant="contained"
                            color="primary"
                            className={classes.buttonStyle}
                        >
                            {t('add_to_wallet')}
                        </Button>
                    </Grid>
                    
                </Grid>
            </Grid>
            <MaterialTable
                title={t('wallet_requests')}
                columns={columns}
                data={data}
                style={{direction:isRTL ==='rtl'?'rtl':'ltr', marginTop: '20px'}}
                        options={{
                            exportButton: true,
                        }}
                localization={{
                    body:{
                        addTooltip: (t('add')),
                        deleteTooltip: (t('delete')),
                        editTooltip: (t('edit')),
                        emptyDataSourceMessage: (
                            (t('blank_message'))
                        ),
                        editRow: { 
                            deleteText: (t('delete_message')),
                            cancelTooltip: (t('cancel')),
                            saveTooltip: (t('save')) 
                        }, 
                    },
                    toolbar: {
                        searchPlaceholder: (t('search')),
                        exportTitle: (t('export')),
                    },
                    header: {
                        actions: (t('actions')) 
                    },
                    pagination: {
                        labelDisplayedRows: ('{from}-{to} '+ (t('of'))+ ' {count}'),
                        labelRowsSelect: (t('rows')),
                        firstTooltip: (t('first_page_tooltip')),
                        previousTooltip: (t('previous_page_tooltip')),
                        nextTooltip: (t('next_page_tooltip')),
                        lastTooltip: (t('last_page_tooltip'))
                    },
                }}
                editable={{
                    onRowUpdate: (newData, oldData) => editData(newData),
                    onRowDelete: oldData =>
                        settings.AllowCriticalEditsAdmin?
                        new Promise(resolve => {
                            setTimeout(() => {
                                resolve();
                                console.log(oldData);
                                dispatch(editWalletAddRequest(oldData,"Delete"));
                            }, 600);
                        })
                        :
                        new Promise(resolve => {
                            setTimeout(() => {
                                resolve();
                                alert(t('demo_mode'));
                            }, 600);
                        })
                }}
            />
            <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>{commonAlert.msg}</AlertDialog>
        </div>
    );
}